import StorageManager from './storage-manager.class';

const storageManager = new StorageManager();
let initialized = false;

export default {
  install(Vue) {
    Vue.mixin({
      data() {
        return {
          storageManager,
        };
      },
      created() {
        if (!initialized) {
          storageManager.init();
        }
      },
    });
  },
};
